import LinkIcon from "@mui/icons-material/Link";
import LinkOffIcon from "@mui/icons-material/LinkOff";
import { IconButton, Link, Stack, Tooltip } from "@mui/material";
import { useDeleteSharedCard } from "../hooks/useDeleteSharedCard";
import { useTranslator } from "../i18n/translator";
import { ButtonWithConfirmation } from "./ButtonWithConfirmation";

export const SharedLink = ({
  shared,
  cardId,
  projectId,
  responsibleProjectId,
}: {
  shared: boolean;
  cardId: string;
  projectId: string;
  responsibleProjectId: string;
}) => {
  const translate = useTranslator();
  const { mutate: deleteSharedCard } = useDeleteSharedCard(projectId);
  return (
    shared && (
      <Stack direction="row" spacing={1} alignItems="center">
        <ButtonWithConfirmation
          handleConfirm={() => deleteSharedCard(cardId)}
          dialogTitle={translate("deleteConfirmationTitle")}
          dialogMessage={translate("deleteSharedConfirmationMessage")}
        >
          <Tooltip
            title={translate("removeSharedCard")}
            placement="bottom"
            arrow
            disableInteractive
          >
            <IconButton
              color="error"
              size="small"
              disabled={false}
              aria-label={translate("removeSharedCard")}
            >
              <LinkOffIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </ButtonWithConfirmation>
        <Tooltip
          title={translate("openResponsibleProject")}
          placement="bottom"
          arrow
          disableInteractive
        >
          <Link
            href={`/projects/${responsibleProjectId}`}
            aria-label={translate("openResponsibleProject")}
          >
            <LinkIcon
              fontSize="small"
              color="primary"
              sx={{ verticalAlign: "middle" }}
            />
          </Link>
        </Tooltip>
      </Stack>
    )
  );
};
